<template>
  <div class="app-container flex-table-container">
    <el-form ref="searchModel" :model="searchModel" label-width="auto" class="table-query-form">
      <el-form-item prop="keywords" label="标签模版名称">
        <el-input
          v-model="searchModel.keywords"
          placeholder="请输入"
          clearable
          @keyup.enter.native="getTableData(true)"
        ></el-input>
      </el-form-item>
      <el-form-item label="是否默认模版" prop="isDefault">
        <el-select v-model="searchModel.isDefault" placeholder="请选择" clearable>
          <el-option label="是" :value="1"></el-option>
          <el-option label="否" :value="0"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item class="form-btn" label-width="0">
        <el-button type="success" @click="getTableData(true)">查询</el-button>
        <el-button @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>

    <div class="cbox-p14 table-main">
      <TableHeader :refTable="refTable" storageKey="hiddenColumns_label" @onRefresh="getTableData()">
        <el-button type="primary" @click="handleAdd">新增</el-button>
      </TableHeader>

      <el-table ref="table" :data="tableData" border stripe height="100%" style="width: 100%" v-loading="tableLoading">
        <el-table-column label="序号" align="center" width="50" fixed>
          <template v-slot="{ $index }">
            <span>{{ (searchModel.pageNum - 1) * searchModel.pageSize + $index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="模版名称" prop="title" min-width="120" header-align="center" fixed></el-table-column>
        <el-table-column label="是否为默认模版" width="140" align="center">
          <template v-slot="{ row }">
            <el-tag v-if="row.isDefault == 1" type="success">是</el-tag>
            <el-tag v-else type="info">否</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="remark" min-width="180" header-align="center"></el-table-column>
        <el-table-column label="创建/修改人" width="140" align="center" prop="createByName"></el-table-column>
        <el-table-column label="创建/修改时间" width="160" align="center" prop="updatetime"></el-table-column>

        <el-table-column label="操作" width="140" align="center" fixed="right">
          <template v-slot="{ row }">
            <el-link type="primary" @click="handlePreview(row)">预览</el-link>
            <el-link type="primary" @click="handleEdit(row)">编辑</el-link>
            <el-link v-if="row.isDefault != 1" type="danger" @click="handleDelete(row)">删除</el-link>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page="searchModel.pageNum"
        :page-size="searchModel.pageSize"
        background
        layout="total, prev, sizes ,pager, next, jumper"
        :total="dataTotal"
        @current-change="onCurrentChange"
        @size-change="onSizeChange"
      ></el-pagination>
    </div>

    <!-- 预览 -->
    <HiprintPreview :visible.sync="previewVisible" :activeInfo="activeRowInfo" />
    <!-- 编辑 -->
    <TemplateEdit :visible.sync="editVisible" :activeId="activeRowId" @refresh="getTableData" />
  </div>
</template>

<script>
import TableHeader from '@/components/TableHeader';
import HiprintPreview from './components/HiprintPreview';
import TemplateEdit from './components/TemplateEdit';

import { providerList } from './basisData/printProviders';

import { getFormTemplateList, deleteFormTemplate } from '@/api/system';

export default {
  components: { TableHeader, HiprintPreview, TemplateEdit },
  data() {
    return {
      refTable: null,
      searchModel: {
        pageNum: 1,
        pageSize: 20,
        keyword: ''
      },
      typeList: [],
      dataTotal: 0,
      tableLoading: false,
      tableData: [],
      activeRowId: null,
      activeRowInfo: {},
      editVisible: false,
      previewVisible: false
    };
  },
  computed: {},
  watch: {},
  methods: {
    handleReset() {
      this.$refs.searchModel.resetFields();
      this.getTableData();
    },
    onCurrentChange(pageNum) {
      this.searchModel.pageNum = pageNum;
      this.getTableData();
    },
    onSizeChange(pageSize) {
      this.searchModel.pageNum = 1;
      this.searchModel.pageSize = pageSize;
      this.getTableData(true);
    },
    async getTableData(isFirstPage = false) {
      if (isFirstPage) this.searchModel.pageNum = 1;
      this.tableLoading = true;

      const startDate = this.searchModel?.dateRange?.[0] ?? null;
      const endDate = this.searchModel?.dateRange?.[1] ?? null;
      const startTime = startDate ? startDate + ' 00:00:00' : null;
      const endTime = endDate ? endDate + ' 23:59:59' : null;

      const { data } = await getFormTemplateList({ ...this.searchModel, startTime, endTime });

      this.dataTotal = data.count;
      this.tableData = data.list || [];
      this.tableLoading = false;
    },
    handlePreview(row) {
      const provider = providerList[row.type];

      this.activeRowInfo = { ...provider, ...row };
      this.previewVisible = true;
    },
    handleAdd() {
      this.activeRowId = null;
      this.editVisible = true;
    },
    handleEdit(row) {
      this.activeRowId = row.id;
      this.editVisible = true;
    },
    handleDelete(row) {
      this.$confirm('确定删除所选信息吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          await deleteFormTemplate({ id: row.id });

          this.$message.success('删除成功');
          this.getTableData();
        })
        .catch(() => {});
    }
  },
  created() {},
  mounted() {
    this.refTable = this.$refs.table;
  },
  activated() {
    this.getTableData();
    this.$nextTick(() => {
      this.$refs.table.doLayout(); // 重置表格布局
    });
  } //页面有keep-alive触发
};
</script>

<style lang="scss" scoped></style>
